var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page rowBackgroundHomepage " }, [
    _c("div", { staticClass: "page-content" }, [
      _c(
        "div",
        { staticClass: "listPage" },
        [
          _c("div", { staticClass: "row showLargeScreenOnly" }),
          _vm._v(" "),
          _c("BackButton", { attrs: { returnUrl: "/bankAccounts/" } }),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "itemList" },
            [
              _c(
                "f7-list",
                {
                  staticClass: "searchbar-found polsize",
                  attrs: { id: "bank-list" },
                },
                _vm._l(this.report, function (account) {
                  return _c(
                    "f7-list-item",
                    {
                      key: account.line - 1,
                      staticClass: "bankAccountList boxRequest",
                      attrs: {
                        media:
                          "<i class='icon list-icon " +
                          _vm.getClassStatus(account.status) +
                          "'></i>",
                        title: account.line - 1 + ": " + account.name,
                        subtitle: account.status,
                      },
                    },
                    [_vm._v(_vm._s(account.description) + "\n          ")]
                  )
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }